// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"20":"77cd4aa2","320":"49b77f3d"}[chunkId] + ".js";
};